/*eslint-disable */
import { MenuItem, TextField } from "@material-ui/core";
import React, { useState, useEffect, useRef } from "react";
import { selectedVendor, selectVendor, vendorCodes } from "../../store";
import { useRecoilState } from "recoil";
import { DropdownIcon } from "../../assets/Icons";
import { getVendorCode } from "../../services/purposeCode";
import Select from "react-select";

interface Vendor {
  displayName: string;
  userId: string;
  vendorCode: string;
}

interface VendorDropdownProps {
  onVendorChange?: any
}

const VendorDropdown: React.FC<VendorDropdownProps> = ({ onVendorChange }) => {
  const [vendorData, setVendorData] = React.useState<any>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [showVendorList, setShowVendorList] = React.useState<boolean>(false);
  const [selectedVendor, setSelectedVendor] = React.useState<any>({});
  const [vendorCode, setVendorCode] = useRecoilState(selectVendor)
  const [isEdited, setIsEdited] = useState(false);

  const parentRef = useRef<HTMLDivElement>(null);
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");

  const defaultVendor =
    vendorData.filter((item: any) => {
      return (item.userId === currentUser.vendor_key)
    })

  useEffect(() => {
    setVendorCode(selectedVendor)
  }, [selectedVendor])

  useEffect(() => {
    localStorage.setItem("vendorCode", JSON.stringify(vendorCode));
  }, [vendorCode]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (parentRef.current && !parentRef.current.contains(event.target as Node)) {
        setShowVendorList(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!isEdited && defaultVendor?.[0]?.vendorCode) {
      const found = vendorData.find(
        (v: any) => v.vendorCode === defaultVendor[0].vendorCode
      );
      if (found) {
        setSelectedVendor(found);
        setSearchQuery(found.vendorCode);
        setVendorCode(found);
      }
    }
  }, [defaultVendor, isEdited, vendorData]);


  useEffect(() => {
    handleVendorCodes()
  }, [])


  const handleVendorCodes = () => {
    getVendorCode()
      .then((res: any) => {
        setVendorData(res?.data);
      })
      .catch((error) => {
        console.error("ERROR", error);
      });
  };


  const handleInputChange = (e: any) => {
    setSearchQuery(e.target.value);
    setIsEdited(true);

    if (e.target.value.trim() === '') {
      setVendorCode({
        vendorCode: "",
        userId: "",
        displayName: ""
      });
    }
  };


  return (
    <Select<{ displayName: any; vendorCode: any, userId:any }>
      options={vendorData.map((c: any) => ({
        displayName: c?.displayName,
        vendorCode: c?.vendorCode,
        userId: c?.userId
      }))}
      getOptionLabel={(o) => o.displayName}
      getOptionValue={(o) => o.vendorCode}
      value={selectedVendor}
      onChange={(opt) => {
        setIsEdited(true)
        setSelectedVendor(opt ?? null);
        onVendorChange(opt?.vendorCode ?? "");
      }}
      filterOption={(candidate, input) => {
        const hay = `${candidate.data.vendorCode} ${candidate.data.displayName}`.toLowerCase();
        return hay.includes(input.toLowerCase());
      }}
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: "#dbeafe",
          alignSelf: "stretch",
          color: "#b5b5bd",
          fontFamily: "Inter",
          fontSize: "20px",
          fontWeight: 500,
          fontStyle: "normal",
          height: "100%",
          width: "370px",
          borderColor: "#e5e7eb",
          boxShadow: "none",
          borderRadius: "none",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
          cursor: "pointer",
          outline: "none",
          ":hover": {
            borderColor: "#e5e7eb",
          },
          padding: "12px 16px"
        }),
        indicatorSeparator: () => ({ display: "none" }),
        valueContainer: (base) => ({ ...base, padding: 0, margin: 0 }),
        input: (base) => ({ ...base, margin: 0, padding: 0 }),
        placeholder: (base) => ({ ...base, margin: 0, padding: 0 }),
        menu: (base) => ({
          ...base,
          zIndex: 9999,
          fontFamily: "Inter",
          fontSize: "14px",
          maxWidth: "370px"
        }),
        option: (base, { isFocused }) => ({
          ...base,
          backgroundColor: isFocused ? "#f0f0f0" : "#fff",
          color: "#425466",
          padding: "10px 18px",
          cursor: "pointer",
        }),
        singleValue: (base) => ({ ...base, margin: 0, color: "#425466" }),
        dropdownIndicator: (base) => ({
          ...base,
          padding: "0px",
          paddingRight: "1px"
        }),
      }}
      components={{ IndicatorSeparator: () => null }}
      isSearchable
      isDisabled={!currentUser?.username?.endsWith("@moneyhop.co")}
      formatOptionLabel={(option) => (
        <div style={{ display: "flex", alignItems: "start", gap: "14px", maxWidth: "370px" }}
          id={option.vendorCode}>
          <div>
            <div style={{ fontSize: "18px", color: "#000" }}>{option.displayName}</div>
            {/* <div style={{ fontSize: "12px", color: "#425466" }}>{option.displayName}</div> */}
          </div>
        </div>
      )}
      isClearable
    />
  );
};

export default VendorDropdown;
